import React, { useRef, useState } from 'react';

export default function ContactForm() {
  const formRef = useRef(null);
  const [responseMessage, setResponseMessage] = useState(null);
  const [responseType, setResponseType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  // Handler for input field changes
  const handleInputChange = event => {
    const { name, value } = event.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async event => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.target);

    formData.append('access_key', '856433d7-4fd2-4a29-a17b-89a1f366a8b4');

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: json,
    }).then(res => res.json());

    if (res.success) {
      setResponseType('success')
      setResponseMessage("🎉 Form Submitted Successfully! 🚀 We'll get back to you soon—faster than an optimized SQL query! Meanwhile, grab a coffee ☕ and let the magic happen! ✨");
      setFormData({ name: '', email: '', subject: '', message: '' });
      setLoading(false);
    }else{
      setResponseType('danger')
      setResponseMessage("⚠️ Oops! Something went wrong. 🛠️ - Even the best code hits a bug sometimes! Try again or refresh—meanwhile, debugging mode activated! 🐛🚀");
      setLoading(false);
    }

    // Scroll to the top of the form
    const yOffset = -150; // Adjust to scroll 150px beyond the element
    const yPosition = formRef.current.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: yPosition, behavior: "smooth" });

    setTimeout(() => {
        setResponseMessage(null); // Reset message after 5 seconds
    }, 10000);
  };
  return (
    <form id="contact-form" ref={formRef} onSubmit={onSubmit}>
      { responseMessage && <div class={`alert alert-${responseType}`} role="alert">{responseMessage}</div> }
      <div className="row gx-3 gy-4">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label">Your Name</label>
            <input
              name="name"
              placeholder="Name *"
              className="form-control"
              type="text"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label">Your Email</label>
            <input
              name="email"
              placeholder="Email *"
              className="form-control"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="form-label">Subject</label>
            <input
              name="subject"
              placeholder="Subject *"
              className="form-control"
              type="text"
              value={formData.subject}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <label className="form-label">Your message</label>
            <textarea
              name="message"
              placeholder="Your message *"
              rows={4}
              className="form-control"
              value={formData.message}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="col-md-12">
          <div className="send">
          <button className={`px-btn w-100 ${loading ? 'disabled' : ''}`} type="submit">
            {loading ? (
              <>
                Sending &nbsp;
                <div className="spinner-border text-light me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </>
            ) : (
              'Send Message'
            )}
          </button>
          </div>
        </div>
      </div>
    </form>
  );
}
